export const DATA_3 = {
    name: '小販文化',
    tabs: [
        {
            name: '報章評論',
            url: 'http://news.example.com/hk-hawker-culture',
            contents: [
                {
                    type: 'html', html: `<br/>
                    <div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%; gap: 16px;'>
                        <div class='w-full font-bold text-white flex flex-row items-center' style='background-color: #3F96FD; padding: 16px; gap:16px;'>
                            <div style='width:12px; height:39px; background-color: #FF7961;'></div>
                            報章評論 | 小販漸少 香港街頭文化何去何從
                        </div>
                        <div style='width: 100%; padding-left:0%; padding-right:0%; display: flex; flex-direction: column; align-items: start;'>
                           <br/>
                            
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港近年積極推動「無處不旅遊」，希望讓旅客體驗更地道的香港生活。傳統飲食一直是香港最具吸引力的特色之一，旅遊發展局亦把小販文化視為本地多元飲食文化的一部分。然而，一些沿用多年的政策和管理措施，正令小販更難繼續經營，也使傳統手藝難以傳承。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;92歲的流動小販陳德貞便因牌照制度而遲遲未能退休。按照現行規例，持牌人必須親自在攤檔工作，也只有本人可以售賣貨品。因此，即使年事已高，她也要整日在炎熱天氣下工作。她希望把牌照交給有經驗的助手接手，但流動小販牌照不能轉讓。這也意味着隨着現有持牌人年老退休，流動小販的數目將會持續減少。</p><br/>
                        </div>
                    </div>` },
                { type: 'image', src: '/secondary/tasks/B1-P1-img.png' },
                {
                    type: 'html', html: `<div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%; gap: 16px;'>
                        <div style='width: 100%; padding-left:0%; padding-right:0%; display: flex; flex-direction: column; align-items: start;'>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;現行小販政策可追溯至1972年。當時香港的小販數目很多，在1974年，香港平均每一萬名居民，便有約150個小販攤檔，可見當時街頭小販十分普遍。這引發了市民對衞生、安全及阻塞街道等問題的擔憂。然而，今天的情況已大不相同。2000年至2024年間，流動小販數目下跌約八成，目前只餘233名；固定攤位小販牌照亦減少約四成，目前不足5000個。過去為控制小販數目而制定的措施，是否仍完全適合今天的情況，值得重新考慮。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目前，政府仍較關注小販可能帶來的衞生、安全和街道秩序問題，對小販的文化和旅遊價值則較少重視。其實，亞洲不少城市都以熱鬧的街頭市集和地道小食吸引旅客，街頭飲食也成為遊客了解當地的一種方式。香港應該重新檢視現行規例，在維持衞生、安全和街道秩序的同時，適度放寬限制，讓小販有更多生存和發展的空間。若特色攤檔和傳統手藝得以保留，小販文化便更有機會延續，並繼續成為香港城市生活和旅遊體驗的一部分。</p><br/>
                            <br/><div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自《南華早報》
                            </div><br/><br/>
                        </div>
                    </div>` },
                {
                    type: 'ai-comments',
                    comment_1: {
                        name: 'James L.',
                        name_abbr: 'JL',
                        comment: '路邊攤檔的衞生情況確實值得留意；如果小販在餐廳附近經營，也可能引起店主不滿。不過，不少旅客到中東旅遊時，都會特意逛當地市集，感受當地的飲食和生活文化。香港以前也有自己的街頭小食文化，我小時候放學後經常到旺角和深水埗的小販攤檔買雞蛋仔，現在仍然很懷念。'
                    },
                    comment_2: {
                        name: 'Sievers W.',
                        name_abbr: 'SW',
                        comment: '香港似乎把小販管理想得太複雜了。我現在住在悉尼，當地有些街道會劃出固定空間讓咖啡店擺放戶外桌椅。所以我覺得街道上的飲食活動不一定只能禁止，香港其實也可以想想有沒有類似做法。如果只是因為擔心管理麻煩，就不給小販發展空間，讓這種街頭文化逐漸消失，實在太可惜了。'
                    },
                    comment_3: {
                        name: 'Stephen W.',
                        name_abbr: 'SW',
                        comment: '我認為，單靠懷舊並不能成為保留小販的理由。在街上吃東西並沒有甚麼特別的吸引力，也不能因為它是「傳統文化」，就忽略實際問題。路邊攤檔的衞生情況是否理想，以及附近的洗手間等配套設施是否充足，都是不能忽視的問題。',
                    },
                    comment_ai: {
                        comment: '留言者分別回憶街頭小食、以悉尼為例談街道管理，以及提醒衞生配套問題。悉尼已讓街頭小販有秩序經營，香港值得直接仿效。'
                    }
                },  {
                    type: 'html', html: `<br/><br/><br/><br/>
                            ` 
                },
            ]
        },
        {
            name: '政府資訊',
            url: 'http://gov.example.com/hawker-succession-program',
            contents: [
                {
                    type: 'html',
                    html: `
                    <div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%; gap: 16px;'>
                        <img src='/secondary/tasks/B1-P2-banner.png' style='max-width: 100%; height: auto;'/>
                        <div style='width: 100%; padding-left:0%; padding-right:0%; display: flex; flex-direction: column; align-items: start;'>
                            <br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;不少資深小販年紀漸長，希望退休，卻找不到合適的人接手攤檔。新加坡國家環境局因此推出「小販承前啟後計劃」，協助他們把招牌菜的食譜、烹飪技巧和經營經驗傳給有意入行的年輕一代。不過，資深小販不能自行決定把攤檔交給誰，接班人必須先接受評選和訓練，符合要求後才可正式接手。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;「小販承前啟後計劃」分為四個階段。首先，申請人要接受烹飪測試和面試，由資深小販、新加坡國家環境局及評審人員了解他們是否具備基本的烹飪能力。通過評選後，接班人會跟隨資深小販接受三個月的學徒訓練，學習招牌菜的食譜、烹飪技巧和攤檔的日常經營。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;完成訓練後，接班人還要接受進一步的評核，以檢驗他們是否已掌握招牌菜的味道和烹飪技巧。通過評核後，接班人才可以正式接手攤檔。資深小販也可以選擇繼續指導兩個月，協助接班人適應實際經營。</p><br/>
                            <br/><br/>
                            <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自新加坡國家環境局
                            </div><br/><br/>
                        </div>
                    </div>

                    `
                }

            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '週末，你和爸爸媽媽到深水埗逛街。經過幾個小販攤檔時，爸爸提起自己小時候這一帶的小販比現在多得多；媽媽也說，不少以往常見的街頭小食攤已經消失。你對香港小販的現況產生興趣，便在手機上找到下列一篇評論。<br/><br/>點擊「下一頁」來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 根據社論，香港目前尚有多少名流動小販？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 約150名' },
                { text: 'B. 約233名' },
                { text: 'C. 約1200名' },
                { text: 'D. 約5000名' },
            ],
            tab: 0
        },
        {
            id: '2',
            type: '選擇題',
            question: '2. 社論第二段提到「這也意味着……」，這裏的「這」是指甚麼？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 持牌人年老仍要親自經營攤檔' },
                { text: 'B. 有經驗的助手希望接手原有攤檔' },
                { text: 'C. 流動小販牌照不能轉讓給其他人' },
                { text: 'D. 現時流動小販數目已大幅減少' },
            ],
            tab: 0,
        },
        {
            id: '3',
            type: '選擇題',
            question: '3. 根據陳德貞的個案，如果現行規定不變，她退休後最可能出現甚麼情況？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 助手可沿用原有牌照繼續經營' },
                { text: 'B. 攤檔可能因無人合法接手而結束' },
                { text: 'C. 攤檔會自動轉為固定小販攤位' },
                { text: 'D. 政府會安排其他小販來接手經營' },
            ],
            tab: 0,
        },
        {
            id: '4',
            type: '選擇題',
            question: '4. 綜合社論第2、3段，以下哪項最能概括香港小販面對的處境？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 牌照不能轉讓，小販數目減少' },
                { text: 'B. 小販數目太多，規例需要加強' },
                { text: 'C. 助手經驗不足，難以接手攤檔' },
                { text: 'D. 固定攤位增加，小販轉到室內' },
            ],
            tab: 0,
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. 仔細閱讀三則讀者留言及其下方的AI總結。以下哪項對AI總結的評價不正確？',
            subtitle: '參考右側的讀者留言及AI總結，作答本題。',
            options: [
                { text: 'A. AI誤寫悉尼咖啡店戶外桌椅的實際情況' },
                { text: 'B. AI誇大Sievers建議香港參考做法的程度' },
                { text: 'C. AI遺漏James對衞生及附近店舖的關注' },
                { text: 'D. AI保留三則留言對小販問題的不同看法' },
            ],
            tab: 0,
        },
        {
            id: '6',
            type: '表格問題',
            question: '6. 以下陳述摘錄或改寫自社論和讀者留言。請判斷每項陳述主要屬於可以查證的「事實」，還是帶有判斷或評價的「觀點」。',
            subtitle: '參考右側的「報章評論」及讀者留言，作答本題。',
            header: ['陳述', '事實', '觀點'],
            table: [
                { text: '(1)	旅遊發展局把小販文化視為本地多元飲食文化的一部分。' },
                { text: '(2)	現行小販政策已不能充分配合香港今天的需要，需要思考如何改進。' },
                { text: '(3)	2000年至2024年，流動小販的數目下跌約八成。' },
                { text: '(4)	香港的街頭小食文化值得保留和珍惜。' },
            ]
        },
        {
            type: 'display-text',
            html: '其中幾則留言提到其他城市的街頭小販，引起了你們的興趣。媽媽在網上搜尋其他地方保留小販文化的方法，找到新加坡國家環境局介紹的一項計劃。<br/><br/>點擊「下一頁」來閱讀第二個來源。'
        },
        {
            id: '7',
            type: '選擇題',
            question: '7. 嘉朗整理報章社論和新加坡「小販承前啟後計劃」時，想找出兩個來源都有直接提及的內容。以下哪項符合？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 流動小販牌照不可以轉讓給其他人' },
                { text: 'B. 衞生和街道秩序需要持續受到監管' },
                { text: 'C. 小販手藝需要由下一代接續和傳承' },
                { text: 'D. 街頭飲食可以讓旅客了解本地文化' },
            ],
            tab: 1,
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 新加坡計劃在評選接班人時安排烹飪測試，完成學徒訓練後還需再次評核。這兩次評核的目的有甚麼不同？',
            subtitle: '參考右側的「政府資訊」，作答本題。',
            options: [
                { text: 'A. 先看接班人能力，再看經營表現' },
                { text: 'B. 先看招牌菜技巧，再定訓練內容' },
                { text: 'C. 先看食譜知識，再比較廚藝水平' },
                { text: 'D. 先看基本廚藝，再看招牌菜手藝' },
            ],
            tab: 1,
        },
        {
            id: '9',
            type: '選擇題',
            question: '9. 綜合香港小販面對的問題和新加坡「小販承前啟後計劃」，以下哪項最有助小販文化延續？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 建立接班途徑，傳承原有手藝' },
                { text: 'B. 增加小販牌照，自行選擇攤檔' },
                { text: 'C. 放寬管理政策，減少接班評核' },
                { text: 'D. 保留原有菜式，限制日後改變' },
            ],
            tab: 1,
        },
        {
            id: '10',
            type: '選擇題',
            question: '10. 某城市參考新加坡的做法，試行小販接班計劃。半年後，政府希望評估計劃成效。綜合兩個來源，以下哪組資料最值得重點檢視？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 攤檔佈置保留情況、旅客到訪人數' },
                { text: 'B. 文化宣傳推廣成效、市民參與程度' },
                { text: 'C. 招牌手藝傳承成效、衞生秩序狀況' },
                { text: 'D. 新式菜式推出情況、攤檔收入變化' },
            ],
            tab: 1,
        },
        {
            id: '11',
            type: '短句作答題',
            question: '11. 區議會將舉辦「小販文化推廣日」，請為宣傳展板擬寫一句不超過20字的標語，呼籲市民支持保留小販文化。請綜合兩個來源，並說明理由。',
            subtitle: '結合兩個來源，作答本題。'
        }
    ]
}
